import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import React from 'react'
import useAOS from './useAos'

export default function DescBanner({text}) {
    useAOS()
    return (
    <div 
    className="mt-16 lg:flex-row flex flex-col justify-center gap-16 lg:gap-0 items-center overflow-hidden"  
    data-aos="fade-left"
    data-aos-delay="300"
    data-aos-duration="600">
            <div className="flex justify-center items-center flex-col lg:w-1/2">
                <DotLottieReact
                    src="https://lottie.host/fba4a110-2fed-4b03-b2ab-9cd5b39094c4/aN4746DDZT.lottie"
                    loop
                    autoplay
                    className='h-96'
                    />
                    <h1 className='text-4xl font-bold font-orbitron'>ARCIUM STUDIO</h1>
            </div>
            
            <div className="lg:w-1/2 flex flex-col p-10">
                <div className='flex flex-col gap-6 w-full 2xl:w-3/4 p-5 lg:text-left text-left md:text-center bg-hover rounded-3xl'>
                    <p className='text-color1 font-quantico'>{text}</p>
                </div>
            </div>
        </div>
  )
}
